/**
 * Website and clinic fields of Edit profile (Bloom 2.0 C1). The limits and rules mirror
 * apps/api/internal/domain/doctors/profile.go: the form shows the error under the field, the
 * backend refuses the same input. Runs without a test framework: see doctor-profile-links.test.ts.
 */
export const WEBSITE_MAX = 200;
export const CLINIC_NAME_MAX = 120;
export const CLINIC_PHONE_MAX = 32;
export const CLINIC_DESCRIPTION_MAX = 500;
const CLINIC_PHONE = /^\+?[0-9][0-9 ()\-.]{4,}[0-9]$/;
export function isValidWebsite(raw) {
    const value = raw.trim();
    if (!value)
        return true;
    if (/\s/.test(value))
        return false;
    const full = value.includes("://") ? value : `https://${value}`;
    if (full.length > WEBSITE_MAX)
        return false;
    try {
        const url = new URL(full);
        if (url.protocol !== "http:" && url.protocol !== "https:")
            return false;
        const host = url.hostname;
        return host.includes(".") && !host.startsWith(".") && !host.endsWith(".");
    }
    catch (_a) {
        return false;
    }
}
export function validateProfileLinks(website, clinic) {
    const errors = {};
    if (!isValidWebsite(website))
        errors.website = "website";
    if (!clinic)
        return errors;
    const name = clinic.name.trim();
    const phone = clinic.phone.trim();
    const site = clinic.website.trim();
    const description = clinic.description.trim();
    // «Add clinic» pressed and left blank is simply no clinic
    if (!name && !phone && !site && !description)
        return errors;
    if (!name)
        errors.clinicName = "clinicName";
    if (phone && !CLINIC_PHONE.test(phone))
        errors.clinicPhone = "clinicPhone";
    if (!isValidWebsite(site))
        errors.clinicWebsite = "clinicWebsite";
    return errors;
}
function normalized(clinic) {
    if (!clinic)
        return "";
    const parts = [clinic.name, clinic.phone, clinic.website, clinic.description];
    const trimmed = parts.map((part) => part.trim());
    return trimmed.some(Boolean) ? JSON.stringify(trimmed) : "";
}
export function sameClinic(a, b) {
    return normalized(a) === normalized(b);
}
